var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',_vm._l((_vm.alerts),function(alert){return _c('Alert',{key:alert.summary,staticClass:"mt-4",attrs:{"autohide":_vm.autohide,"alert":alert}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }